import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Grid, Modal, CircularProgress } from "@mui/material";

import useZone from "../../../../hooks/user/useZone";
import useAuth from "../../../../hooks/useAuth";

import { ModalButton as Button } from "../../common/styled";

// import { Close as CloseIcon } from "@mui/icons-material";
import { ReactComponent as CancelIcon } from "../../../../vendor/button/cancel.svg";
import { ReactComponent as ConfirmIcon } from "../../../../vendor/button/confirm.svg";
import ModalBox from "../../../common/ModalBox";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 160px;
`;

function DeleteZoneModal({ open, handleClose, zoneID, deleteFlag, removeFlag }) {
  const theme = useTheme();
  const isMD = useMediaQuery(theme.breakpoints.up("md"));
  const [deleting, setDeleting] = React.useState(false);
  const { deleteZone, restoreZone, getZones, getZonesForList } = useZone();
  const { setZoneController } = useAuth();
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
      >
        <ModalBox
          sx={{ width: isMD ? "640px" : "90vw", background: "white!important" }}
          handleClose={handleClose}
          title={removeFlag ? "Remove Zone" : deleteFlag ? "Delete Zone" : "Restore Zone"}
        >
          {deleting ? (
            <>
              <Root>
                <CircularProgress color="primary" />
              </Root>
            </>
          ) : (
            <Grid container pt={4}>
              <Grid item xs={12} sx={{ margin: "auto", textAlign: "left" }}>
                {removeFlag && "Are you sure you want to permanently remove the following zone(s)? "}
                {removeFlag && <br />}
                {removeFlag
                  ? "If you remove the following zone(s), you can't recover them forever."
                  : deleteFlag
                  ? "Are you sure you want to permanently delete the following zone(s)?"
                  : "Are you sure you want to permanently restore the following zone(s)?"}
                <br />
                {"string" === typeof zoneID ? (
                  <>
                    <br />
                    {zoneID}
                  </>
                ) : "object" === typeof zoneID && Array.isArray(zoneID) && 0 < zoneID.length ? (
                  zoneID.map((zone_id) => (
                    <>
                      <br />
                      {zone_id}
                    </>
                  ))
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item xs={12} mt={10} textAlign={"right"}>
                <Button variant="outlined" color="primary" size="modal" onClick={handleClose} mr={4} startIcon={<CancelIcon />}>
                  No
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  size="modal"
                  disabled={deleting}
                  onClick={async () => {
                    setDeleting(true);
                    let res;
                    if (deleteFlag) {
                      res = await deleteZone(zoneID, removeFlag);
                    } else {
                      res = await restoreZone(zoneID);
                    }
                    if (res) {
                      getZonesForList();
                      getZones(setZoneController);
                    }
                    setDeleting(false);
                    handleClose();
                  }}
                  startIcon={<ConfirmIcon />}
                >
                  Yes
                </Button>
              </Grid>
            </Grid>
          )}
        </ModalBox>
      </Modal>
    </React.Fragment>
  );
}

export default DeleteZoneModal;
